'use client';

import React, { PropsWithChildren } from 'react';
import { cn } from '@ecom/helper-react-class-combine';
import { useCarouselContext } from '../carousel-context';

interface ViewportProps extends PropsWithChildren {
  className?: string;
  trackClassName?: string;
}

/** Scroll viewport. Slides are passed as children (kept as server components). */
export function CarouselViewport({
  className,
  trackClassName,
  children,
}: ViewportProps): React.ReactElement {
  const { viewportRef } = useCarouselContext();
  return (
    <div className={cn('overflow-hidden', className)} ref={viewportRef}>
      <div className={cn('flex', trackClassName)}>{children}</div>
    </div>
  );
}
